import React from "react";
import { useLocation, useMatches, useNavigate } from "react-router-dom";
import hamburgerIcon from '../icons/hamburger.svg';
import xIcon from '../icons/x.svg';
import CartIcon from "../icons/CartIcon";
import TicketsIcon from "../icons/TicketsIcon";
import localDao from "../data/localDao";
import NumbersUtil from "../util/NumbersUtil";
import ReactGA from "react-ga4";

const Header = () => {
    const matches = useMatches();
    var menuOpen = matches.filter((match) => match.handle?.isMenu).map((match) => match.handle.isMenu).pop();
    const navigate = useNavigate();
    const location = useLocation();
    var currentPath = location.pathname;
    var itemCount = Object.keys(localDao.getCart()).length;
    //for returning to the same page where menu was opened from
    var beforeMenu;
    if (menuOpen && !beforeMenu) {
        beforeMenu = location.state.from;
        //console.log(beforeMenu);
    }
  

    const calculatePrice = () => {
        var cart = localDao.getCart();
        var sum = 0;
        Object.entries(cart).forEach((entry) => {
          var game = entry[1];
          var rows = game.rows;
          sum += game.stake * rows.length * game.drawCount;
        });
        sum = sum / 100;
        return NumbersUtil.padPrice(sum);
      };
      ReactGA.initialize([
        {
           trackingId: "G-ZT04N5TSJWxxx",     

        }
      ]);
      
      ReactGA.event({
        category: "pageview",
        action: window.location.pathname + window.location.search,
      
      });
      

    return (
        <div>
            <div className="flexCenter padding1">
                <img alt='' onClick={() => navigate(process.env.PUBLIC_URL + '/')} className="headerLogo" src={`${process.env.PUBLIC_URL}/img/EL_digilipik_blue.svg`}></img>
                <div className='flexEnd flexCenter'>
                    <div onClick={() => navigate(process.env.PUBLIC_URL + "/")} className="inlineFlex">
                    <div className="darkBlueBold15">{calculatePrice()}</div>
                        </div>
                </div>
            </div>
        </div>
    );
};

export default Header;